import React, { useState } from 'react'
import Loader from '../components/Loader'
import ApiService from '../helpers/api'
import userService from '../helpers/user.service'

export function Login ({ loggedIn, setLoggedIn }) {
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState({ username: '', password: '' })
  const [error, setError] = useState({ username: '', password: '', global: '' })
  const api = new ApiService()

  const validate = () => {
    if (user.username && user.password) {
      return true
    }
    setError({
      username: (!user.username) ? 'Este campo es requerido' : '',
      password: (!user.password) ? 'Este campo es requerido' : ''
    })

    return false
  }

  const handleSubmit = event => {
    if (validate()) {
      setLoading(true)
      api.login(user).then(response => {
        if (response.data) {
          userService.setUser(response.data)
          setLoggedIn(true)
        }
        setLoading(false)
        return response?.data
      }).catch(error => {
        if (error.response.data.detail) {
          setError({
            global: error.response.data.detail
          })
        } else {
          setError({
            global: 'Ha ocurrido un error inesperado'
          })
        }
        setLoading(false)
      })
    }
    event.preventDefault()
  }

  const handleChange = event => {
    setUser({
      ...user,
      [event.target.name]: event.target.value
    })
  }

  return (
    <div id="login">
        <div className="wrapper">
          <div className="cols">
            <div className="col">
              <div className="styled-form genericFormInit loginForm">
                <h2 className="subtitle center">Iniciar sesión</h2>
                <form className="styled-form genericFormInit loginForm" onSubmit={handleSubmit}>
                  <div className="cols">
                    <div className="col total">
                      <span className="text">Usuario</span>
                      <input
                        type="text"
                        name="username"
                        placeholder="Ingrese su usuario..."
                        className="input"
                        onChange={handleChange}
                        value={user.username}
                      />
                    {(error.username !== '') ? (<label generated="true" className="error">{error.username}</label>) : ''}
                    </div>
                    <div className="col total">
                      <span className="text">Contraseña</span>
                      <input
                        type="password"
                        name="password"
                        placeholder="Ingrese su contraseña..."
                        className="input"
                        onChange={handleChange}
                        value={user.password}
                      />
                      {(error.password !== '') ? (<label generated="true" className="error">{error.password}</label>) : ''}
                    </div>
                    {(error.global !== '') ? (<label generated="true" className="error">{error.global}</label>) : ''}
                    <div className="submit-holder">
                        <button type="submit" className="border-btn">
                        <Loader loading={loading} inButton={true}/><p style={{ display: !loading ? 'block' : 'none' }}>Ingresar</p>
                        </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}
